// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Layout from "../shared/Layout.re.mjs";
import * as Router from "../shared/Router.re.mjs";
import * as Core__Option from "@rescript/core/src/Core__Option.re.mjs";
import * as WaitForMessages from "../shared/i18n/WaitForMessages.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

import { t } from '@lingui/macro'
;

function LoginPage(props) {
  var match = ReactRouterDom.useLocation();
  var search = match.search;
  var match$1 = ReactRouterDom.useSearchParams();
  var returnUrl = Core__Option.map(Router.SearchParams.get(match$1[0], "return"), (function (l) {
          return l;
        }));
  return JsxRuntime.jsx(WaitForMessages.make, {
              children: (function () {
                  return JsxRuntime.jsxs(Layout.Container.make, {
                              children: [
                                JsxRuntime.jsxs("h1", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: t`login with Line`,
                                              className: "text-base leading-6 text-gray-500"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: t`privacy disclosure`,
                                              className: "mt-1 text-2xl font-semibold leading-6 text-gray-900"
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsx("h2", {
                                      children: t`we will collect the following information from your Line account`,
                                      className: "mt-4 text-lg font-semibold leading-6 text-gray-900"
                                    }),
                                JsxRuntime.jsxs("dl", {
                                      children: [
                                        JsxRuntime.jsx("dt", {
                                              children: t`email address`,
                                              className: "mt-4 text-lg font-semibold leading-6 text-gray-900"
                                            }),
                                        JsxRuntime.jsx("dd", {
                                              children: JsxRuntime.jsxs("ul", {
                                                    children: [
                                                      JsxRuntime.jsx("li", {
                                                            children: t`notification of updates or cancellations to events (you can opt out)`,
                                                            className: "mt-1"
                                                          }),
                                                      JsxRuntime.jsx("li", {
                                                            children: t`event organizers and other users cannot view your email`,
                                                            className: "mt-1"
                                                          })
                                                    ],
                                                    className: "list-disc list-inside"
                                                  }),
                                              className: "mt-2 text-base leading-6 text-gray-500"
                                            }),
                                        JsxRuntime.jsx("dt", {
                                              children: t`display name`,
                                              className: "mt-4 text-lg font-semibold leading-6 text-gray-900"
                                            }),
                                        JsxRuntime.jsx("dd", {
                                              children: t`publicly displayed on event attendance lists`,
                                              className: "mt-2 text-base leading-6 text-gray-500"
                                            }),
                                        JsxRuntime.jsx("dt", {
                                              children: t`profile picture`,
                                              className: "mt-4 text-lg font-semibold leading-6 text-gray-900"
                                            }),
                                        JsxRuntime.jsx("dd", {
                                              children: t`publicly displayed on event attendance lists`,
                                              className: "mt-2 text-base leading-6 text-gray-500"
                                            })
                                      ],
                                      className: ""
                                    }),
                                JsxRuntime.jsx("a", {
                                      children: t`login with Line`,
                                      className: "block mt-4 text-2xl",
                                      href: "/login" + search
                                    }),
                                JsxRuntime.jsx(ReactRouterDom.Link, {
                                      to: Core__Option.getOr(returnUrl, "/"),
                                      children: t`cancel login`,
                                      className: "block mt-4 text-2xl"
                                    })
                              ]
                            });
                })
            });
}

var make = LoginPage;

export {
  make ,
}
/*  Not a pure module */
